import BaseService from './BaseService';
import apiClient from '../plugins/axios';

class UserService extends BaseService {
  constructor() {
    super('user');
  }

  async getAll() {
    try {
      const response = await apiClient.get('/users');
      return response.data.data || response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async createUser(userData) {
    try {
      const response = await apiClient.post('/user', userData);
      return response.data.data || response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async getUserById(id) {
    try {
      const response = await apiClient.get(`/user/${id}`);
      return response.data.data || response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // { given_name, family_name, roles: string[] }
  async updateUser(id, userData) {
    try {
      const response = await apiClient.put(`/user/${id}`, userData);
      return response.data.data || response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // roles: string[] (role id'leri)
  async assignRolesToUser(userId, roles) {
    try {
      const response = await apiClient.put(`/user/${userId}/role`, { roles });
      return response.data.data || response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }
}

export default new UserService();
